import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { SnCameraStatus } from '@lib/api/entities';

@Component({
  selector: 'sn-camera-status',
  templateUrl: './camera-status.component.html',
  styleUrls: ['./camera-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CameraStatusComponent implements OnInit {
  @Input()
  public status: SnCameraStatus;

  public unmanagedStyles = {
    color: '#FFB028',
    borderColor: '#FFB028',
  };

  public readonly CAMERA_STATUS = SnCameraStatus;

  public ngOnInit(): void {}
}
